import React from 'react';
import Grid from '@material-ui/core/Grid';
import images from '@/assets/images';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';

const NoProducts = ({ title }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={10}
      style={{ marginBottom: 20 }}
    >
      <Grid item>
        <img src={images.noData} width={151} height={151} />
      </Grid>
      <Grid item>
        <span className={classes.emptyProductsTextL}>{title}</span>
      </Grid>
    </Grid>
  );
};

export default NoProducts;
